// extracted by mini-css-extract-plugin
module.exports = {"container":"map_container__1jSIo","heading":"map_heading__2xs4G","text":"map_text__3f_ra","container2":"map_container2__66o2f","mapsection":"map_mapsection__3mj4R"};